// (function () {
//
//     'use strict';
//
//     var ngModule = angular.module('breakmarkApp');
//
//     ngModule.factory('PackageFactory', function() {
//
//         return {
//
//
//             packageProducts: [],
//             calculatedPackageCostBaseline: 0,
//             customerPackage: {},
//             customerPackageProducts: [],
//
//         };
//     });
//
// })();
